define(function(require) {
    var $ = require('jquery');

    if ($('.lead-form, .seminar-reg-form').length <= 0) {
        return;
    } else {
        zipCheck();
        // if someone changes the ZIP code field
        $('input#zip_code').change(function () {
            zipCheck();
        });

        function zipCheck() {
            var zipCode = $('#zip_code').val();
            if ($('#zip_code').length > 0) {
                if (zipCode.length == 5) {
                    $.ajax('/api/enrollment/counties?zipcode=' + zipCode).done(function (data) {
                        var json = $.parseJSON(data);
                        $("#County").empty();
                        $.each(json,
                            function (key, value) {
                                var county = value["Text"];
                                $("#County").append("<option>" + county + "</option>");
                            });

                        if (json.length > 1) {
                            $('#county_select').removeClass('invisible');
                            $('#County').focus();
                        }
                    });
                }
            }
        }

        function highlightErrorFields() {
            $('.lead-form span.field-validation-error, .seminar-reg-form span.field-validation-error').show();
            $('.lead-form span.field-validation-error:visible, .seminar-reg-form span.field-validation-error:visible').each(function (index, element) {
                $(element).parent().parent().addClass('is-error');
                $(element).parent().addClass('is-error');
                $(element).parent().find('input').attr('aria-labelledby', $(element).attr('id')).attr('aria-invalid', 'true');
            });
        }

        function undoErrorFieldHighlights() {
            $('.lead-form span.field-validation-error, .seminar-reg-form span.field-validation-error').each(function (index, element) {
                $(element).parent().parent().removeClass('is-error');
                $(element).parent().removeClass('is-error');
                $(element).parent().find('input').attr('aria-labelledby', $(element).attr('id')).attr('aria-invalid', 'false');
                $(element).hide();
            });
        }

        undoErrorFieldHighlights();
        highlightErrorFields();
    }

});
